
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
    date: '',
    time: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const navigation = [
    { name: 'Ana Sayfa', href: '/' },
    { name: 'Hakkımızda', href: '/about' },
    { name: 'Hizmetler', href: '/services' },
    { name: 'Makaleler', href: '/articles' },
    { name: 'İletişim', href: '/contact' }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    // Validate required fields
    if (!formData.name || !formData.phone || !formData.email || !formData.subject || !formData.date || !formData.time) {
      setSubmitMessage('Lütfen tüm zorunlu alanları doldurun.');
      setIsSubmitting(false);
      return;
    }

    // Validate message length
    if (formData.message.length > 500) {
      setSubmitMessage('Mesaj 500 karakterden fazla olamaz.');
      setIsSubmitting(false);
      return;
    }

    try {
      // Send to Readdy form system
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);
      formDataToSend.append('date', formData.date);
      formDataToSend.append('time', formData.time);

      const response = await fetch('https://readdy.ai/api/form/d3iom6mkn7r41cr5kot0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });

      setSubmitMessage('Randevu talebiniz başarıyla gönderildi. En kısa sürede size dönüş yapacağız.');
      setFormData({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
        date: '',
        time: ''
      });
      setTimeout(() => {
        setIsAppointmentModalOpen(false);
        setSubmitMessage('');
      }, 3000);

    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitMessage('Bir hata oluştu. Lütfen tekrar deneyin.');
    }

    setIsSubmitting(false);
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <Link to="/" className="flex items-center cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/04e25c63716513028a093e30d78ebbd8.png" 
                  alt="Yıldız & Başyiğit Hukuk ve Danışmanlık" 
                  className="h-16 w-auto object-contain"
                />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-slate-700 hover:text-slate-900 font-medium transition-colors cursor-pointer font-poppins"
                >
                  {item.name}
                </Link>
              ))}
            </nav>

            <div className="hidden md:flex items-center space-x-4">
              <button 
                data-appointment-trigger
                onClick={() => setIsAppointmentModalOpen(true)}
                className="bg-slate-900 text-white px-6 py-2 rounded-lg font-semibold hover:bg-slate-800 transition-colors whitespace-nowrap font-poppins cursor-pointer"
              >
                Randevu Al
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-slate-700 hover:text-slate-900 cursor-pointer"
              >
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-4">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-slate-700 hover:text-slate-900 font-medium transition-colors cursor-pointer font-poppins"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                <button 
                  onClick={() => {
                    setIsAppointmentModalOpen(true);
                    setIsMenuOpen(false);
                  }}
                  className="bg-slate-900 text-white px-6 py-2 rounded-lg font-semibold hover:bg-slate-800 transition-colors w-full mt-4 whitespace-nowrap font-poppins cursor-pointer"
                >
                  Randevu Al
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Appointment Modal */}
      {isAppointmentModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-slate-900 font-poppins">Randevu Al</h2>
                <button
                  onClick={() => setIsAppointmentModalOpen(false)}
                  className="text-slate-500 hover:text-slate-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <form id="randevu-formu" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                      Ad Soyad *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 font-poppins font-light text-sm"
                      placeholder="Adınız ve soyadınız"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                      Telefon *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 font-poppins font-light text-sm"
                      placeholder="Telefon numaranız"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 font-poppins font-light text-sm"
                    placeholder="E-posta adresiniz"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                    Konu *
                  </label>
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 pr-8 font-poppins font-light text-sm"
                    required
                  >
                    <option value="">Konu seçiniz</option>
                    <option value="Ticaret ve Şirketler Hukuku">Ticaret ve Şirketler Hukuku</option>
                    <option value="Gayrimenkul ve İnşaat Hukuku">Gayrimenkul ve İnşaat Hukuku</option>
                    <option value="İş Hukuku ve Sosyal Güvenlik">İş Hukuku ve Sosyal Güvenlik</option>
                    <option value="Fikri ve Sınai Mülkiyet Hukuku">Fikri ve Sınai Mülkiyet Hukuku</option>
                    <option value="Ceza Hukuku (Beyaz Yaka Suçları)">Ceza Hukuku (Beyaz Yaka Suçları)</option>
                    <option value="İcra ve İflas Hukuku">İcra ve İflas Hukuku</option>
                    <option value="Sözleşmeler Hukuku">Sözleşmeler Hukuku</option>
                    <option value="Aile Hukuku">Aile Hukuku</option>
                    <option value="İdare ve Vergi Hukuku">İdare ve Vergi Hukuku</option>
                    <option value="Diğer">Diğer</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                      Tercih Edilen Tarih *
                    </label>
                    <input
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 font-poppins font-light text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                      Tercih Edilen Saat *
                    </label>
                    <select
                      name="time"
                      value={formData.time}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 pr-8 font-poppins font-light text-sm"
                      required
                    >
                      <option value="">Saat seçiniz</option>
                      <option value="09:00">09:00</option>
                      <option value="10:00">10:00</option>
                      <option value="11:00">11:00</option>
                      <option value="12:00">12:00</option>
                      <option value="13:00">13:00</option>
                      <option value="14:00">14:00</option>
                      <option value="15:00">15:00</option>
                      <option value="16:00">16:00</option>
                      <option value="17:00">17:00</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2 font-poppins">
                    Mesaj
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-slate-900 resize-none font-poppins font-light text-sm"
                    placeholder="Randevu ile ilgili detayları yazabilirsiniz... (Maksimum 500 karakter)"
                  ></textarea>
                  <div className="text-right text-xs text-slate-500 mt-1 font-poppins">
                    {formData.message.length}/500
                  </div>
                </div>

                {submitMessage && (
                  <div className={`p-3 rounded-lg text-sm font-poppins ${
                    submitMessage.includes('başarıyla') 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {submitMessage}
                  </div>
                )}

                <div className="flex gap-4 pt-4">
                  <button
                    type="button"
                    onClick={() => setIsAppointmentModalOpen(false)}
                    className="flex-1 px-6 py-3 border border-gray-300 text-slate-700 rounded-lg hover:bg-gray-50 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer"
                  >
                    İptal
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex-1 px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors disabled:opacity-50 font-poppins font-semibold whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? 'Gönderiliyor...' : 'Randevu Talep Et'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
